<template>
  <span>
    <!-- Menu lateral do dashboard em telas estreitas (aberto pelo botão hambúrguer da AppBar) -->
    <v-navigation-drawer :value="value" app temporary fixed width="280" @input="$emit('input', $event)">
      <v-list-item class="py-2">
        <v-list-item-avatar>
          <img v-if="avatar" :src="avatar" :alt="'Photo of ' + userName" />
          <v-icon v-else large>mdi-account-circle</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ userName }}</v-list-item-title>
          <v-list-item-subtitle v-if="email && email !== userName">{{ email }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider />
      <v-list nav dense>
        <v-list-item v-for="item in pages" :key="item.to" :to="item.to" exact @click="close">
          <v-list-item-icon><v-icon>{{ item.icon }}</v-icon></v-list-item-icon>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="role.isAdmin" to="/admin/cluster" @click="close">
          <v-list-item-icon><v-icon>mdi-server-network</v-icon></v-list-item-icon>
          <v-list-item-title>Cluster admin</v-list-item-title>
        </v-list-item>
      </v-list>
      <v-divider />
      <v-list nav dense>
        <v-subheader>Help</v-subheader>
        <v-list-item @click="open('guide')">
          <v-list-item-icon><v-icon>mdi-book-open-variant</v-icon></v-list-item-icon>
          <v-list-item-title>Quick guide</v-list-item-title>
        </v-list-item>
        <v-list-item
          href="https://www.notion.so/Ajuda-do-ElectrosFI-cd73ea00c33d4335a8ee1244dac9914c"
          target="_blank"
          rel="noreferrer"
        >
          <v-list-item-icon><v-icon>mdi-open-in-new</v-icon></v-list-item-icon>
          <v-list-item-title>Full documentation</v-list-item-title>
        </v-list-item>
      </v-list>
      <v-divider />
      <v-list nav dense>
        <v-list-item @click="open('settings')">
          <v-list-item-icon><v-icon>mdi-cog</v-icon></v-list-item-icon>
          <v-list-item-title>Settings</v-list-item-title>
        </v-list-item>
        <v-list-item @click="open('logout')">
          <v-list-item-icon><v-icon>mdi-logout</v-icon></v-list-item-icon>
          <v-list-item-title>Log out</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <QuickGuideDialog v-model="dialogs.guide" />
    <v-dialog v-model="dialogs.settings" max-width="500" :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card>
        <v-card-title>
          Settings <v-spacer />
          <v-btn icon aria-label="Close" @click="dialogs.settings = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text><Settings /></v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogs.logout" max-width="400">
      <v-card>
        <v-card-title class="text-h6">Log out?</v-card-title>
        <v-card-text>Your simulations stay saved. You can sign in again with the same account.</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogs.logout = false">Cancel</v-btn>
          <v-btn color="primary" text @click="logout">Log out</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>
<script>
import firebase from "firebase/app";
import { role, loadRole } from "@/common/role";

export default {
  name: "MainNavDrawer",
  components: {
    QuickGuideDialog: () => import("@/components/QuickGuideDialog"),
    Settings: () => import("@/pages/Settings")
  },
  props: {
    value: { type: Boolean, default: false }
  },
  data: () => ({
    pages: [
      { to: "/dashboard", title: "My simulations", icon: "mdi-view-dashboard-outline" },
      { to: "/profile", title: "My profile", icon: "mdi-chart-box-outline" },
      { to: "/examples", title: "Ready-to-run examples", icon: "mdi-flask-outline" },
      { to: "/materials", title: "Materials", icon: "mdi-palette-swatch-outline" }
    ],
    dialogs: { guide: false, settings: false, logout: false }
  }),
  mounted() {
    loadRole();
  },
  computed: {
    role: () => role,
    user() {
      return firebase.auth().currentUser;
    },
    userName() {
      return (this.user && (this.user.displayName || this.user.email)) || "User";
    },
    email() {
      return (this.user && this.user.email) || "";
    },
    avatar() {
      return (this.user && this.user.photoURL) || "";
    }
  },
  methods: {
    close() {
      this.$emit("input", false);
    },
    open(dialog) {
      this.close();
      this.dialogs[dialog] = true;
    },
    logout() {
      firebase
        .auth()
        .signOut()
        .then(() => this.$router.push("/"));
    }
  }
};
</script>
